import React from 'react'
import './index.scss'

interface IFreeGetCardProps {
  color: string;
  cardInfo: IDiyMemberCardStyle;
  buyCard: (e: any) => void;
  isPaid?: boolean;
}

const getStyles = (cardInfo: IDiyMemberCardStyle) => {
  let style = {}
  if (cardInfo.layout === 'small') {
    style = cardInfo.line === 'one' ? { justifyContent: 'center' } : { paddingLeft: '24px' }
  } else if (cardInfo?.nameLayout === 'small') {
    style = { justifyContent: 'flex-end', paddingRight: '30px' }
  } else if (cardInfo.align === 'center') {
    style = { justifyContent: 'center' }
  } else if (cardInfo.align === 'left') {
    style = { paddingLeft: '18px' }
  } else {
    style = { justifyContent: 'right', paddingRight: '16px' }
  }
  return style
}

const FreeGetCard = ({ buyCard, color, cardInfo, isPaid }: IFreeGetCardProps) => {
  return (
    <div className='free-card-box' style={getStyles(cardInfo)}>
      <div data-cypid='homeGetCard' onClick={buyCard} className='free-card' style={{ border: `1px solid ${color}` }}>
        <span style={{ color }}>{isPaid ? i18n.t('mkt.member.buyCards') : i18n.t('mkt.member.freeClaim')}</span>
      </div>
    </div>
  )
}

export default FreeGetCard
